var map = {
	"./base.json": [
		47970,
		7970
	],
	"./de.json": [
		12387,
		2387
	],
	"./fr.json": [
		44403,
		4403
	],
	"./nb.json": [
		74692,
		4692
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 66207;
module.exports = webpackAsyncContext;